import icTimer from '../../../../media/EarlyAccess/ic-timer.svg'
import icTimerDark from '../../../../media/EarlyAccess/ic-timer-dark.svg'
import icWaitlist from '../../../../media/EarlyAccess/ic-waitlist.svg'
import icWaitlistDark from '../../../../media/EarlyAccess/ic-waitlist-dark.svg'
import icGrow from '../../../../media/EarlyAccess/ic-grow-price.svg'
import icGrowDark from '../../../../media/EarlyAccess/ic-grow-price-dark.svg'
import icCheck from '../../../../media/EarlyAccess/ic-check.svg'
import icCheckDark from '../../../../media/EarlyAccess/ic-check-dark.svg'
import icAlert from '../../../../media/EarlyAccess/ic-alert.svg'
import icAlertDark from '../../../../media/EarlyAccess/ic-alert-dark.svg'
import icUser from '../../../../media/EarlyAccess/ic-user.svg'
import icUserDark from '../../../../media/EarlyAccess/ic-user-dark.svg'
import {EarlySocialMedia} from './EarlySocialMediaSection'
import {useIntl} from 'react-intl'
import {useAuth} from '../../auth'
import {useNavigate} from 'react-router-dom'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import Skeleton from 'react-loading-skeleton'
import {useThemeMode} from '../../../../_metronic/partials'
import {useState} from 'react'
import InviteModal from './InviteModal'

export const EarlyLandingPage = ({
  totalWaitingList,
  isOfferClaimed,
  queuePosition,
  isQueueLoading,
}: {
  totalWaitingList: number
  isOfferClaimed: boolean
  queuePosition: number
  isQueueLoading: boolean
}) => {
  const {mode} = useThemeMode()
  const {formatMessage} = useIntl()
  const {companyId, currentUser} = useAuth()
  const [isActive, setIsActive] = useState(false)
  const navigate = useNavigate()
  const isRkAppReady = process.env.REACT_APP_RK_APP_IS_READY === 'true'
  const handleOfferClick = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.EarlyAdopterFormInitiatedSuccessful,
        action: 'normal',
        metadata: {
          company_id: companyId,
          user_id: currentUser?.userId,
          email: currentUser?.email,
          user_hash:currentUser?.user_hash
        },
      },
    })
    navigate('../early-access/form')
  }
  return (
    <>
      <div className='container'>
        {/* Queue Section */}
        <div className='text-center mt-8 px-md-8 px-0'>
          <h3 className='font-size-24 font-semibold'>
            {formatMessage({id: `You're In! But There's a Short Wait...`})}
          </h3>
          <p className='font-size-13 m-0 mt-4'>
            {formatMessage({
              id: `We're rolling out access in batches to ensure the best experience for our early adopters.`,
            })}
          </p>
          <p className='font-size-14 fw-200 m-0 mt-2'>
            {formatMessage({
              id: `  You're on the exclusive waitlist for RecordsKeeper.AI early access`,
            })}
          </p>

          <div
            className='mt-8 p-6 rounded-2'
            style={{
              background: `${mode === 'dark' ? '#45465A' : '#EFF6FF'}`,
              border: '1px solid rgba(13, 33, 109, 0.40)',
            }}
          >
            <h2
              className={`font-size-32 fw-bold m-0 ${
                mode === 'dark' ? 'text-white' : 'text-primary'
              }`}
            >
              <p className='font-size-16 fw-semibold'>
                {formatMessage({id: `Your position in queue`})}
              </p>

              {isQueueLoading ? (
                <Skeleton
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  width={200}
                  height={50}
                />
              ) : (
                <h2
                  className={`font-size-32 fw-bold m-0 mt-4 ${
                    mode === 'dark' ? 'text-white' : 'text-primary'
                  }`}
                >
                  {queuePosition === 0 && !isRkAppReady ? '0 (Launching Soon)' : `#${queuePosition}`}
                </h2>
              )}

              {isQueueLoading ? (
                <Skeleton
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  width={'60%'}
                  height={20}
                />
              ) : (
                <p
                  className={`font-size-13 m-0 mt-4`}
                  style={{color: `${mode === 'dark' ? '#8898A6' : ''}`}}
                >
                  {`of ${totalWaitingList} interested professionals & companies`}
                </p>
              )}
            </h2>

            <button className='btn btn-primary mt-4' onClick={() => setIsActive(true)}>
              {formatMessage({id: `Invite & Jump Ahead`})}
            </button>
          </div>

          <div className='d-flex flex-md-row flex-column justify-between mt-4 text-center w-100 gap-4'>
            <div
              className='text-center w-100 rounded-2 p-6'
              style={{background: `${mode === 'dark' ? '#45465A' : '#EFF6FF'}`}}
            >
              <img
                src={`${mode === 'dark' ? icWaitlistDark : icWaitlist}`}
                alt='icon-waitlist'
                className='mb-2'
              />
              {isQueueLoading ? (
                <div>
                  <Skeleton
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    width={100}
                    height={40}
                  />
                </div>
              ) : (
                <p
                  className='font-size-24 fw-bold m-0 mb-2'
                  style={{color: `${mode === 'dark' ? '#FFFFFF' : '#0D216D'}`}}
                >
                  {totalWaitingList}
                </p>
              )}
              <p
                className='font-size-13 m-0'
                style={{color: `${mode === 'dark' ? '#8898A6' : ''}`}}
              >
                {formatMessage({id: 'Total in waitlist'})}
              </p>
            </div>
            <div
              className='text-center w-100 rounded-2 p-6'
              style={{background: `${mode === 'dark' ? '#45465A' : '#EFF6FF'}`}}
            >
              <img
                src={`${mode === 'dark' ? icTimerDark : icTimer}`}
                alt='icon-wait-time'
                className='mb-2'
              />
              {isQueueLoading ? (
                <div>
                  <Skeleton
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    width={100}
                    height={40}
                  />
                </div>
              ) : (
                <p
                  className='font-size-24 fw-bold m-0 mb-2'
                  style={{color: `${mode === 'dark' ? '#FFFFFF' : '#0D216D'}`}}
                >
                  {formatMessage({id: '2 Week'})}
                </p>
              )}
              <p
                className='font-size-13 m-0'
                style={{color: `${mode === 'dark' ? '#8898A6' : ''}`}}
              >
                {formatMessage({id: 'Estimated wait time'})}
              </p>
            </div>
          </div>
        </div>

        {/* Early Adopter Offer */}
        <div className='mt-8 p-6 px-md-6 px-0 text-center'>
          <h3 className='font-size-18 font-semibold'>
            {formatMessage({id: 'Limited Early Adopter Offer for the First 100 Paid Users!'})}
          </h3>
          <h2 className='font-size-32 font-bold text-primary mt-4'>
            {formatMessage({id: 'Lifetime 50% Off!'})}
          </h2>
          <p className='m-0 mt-4'>
            {formatMessage({
              id: ' Join as the first 100 paid customers and lock in a lifetime 50% discount!',
            })}
          </p>
        </div>

        <div className='d-flex flex-column flex-md-row justify-between mt-4 w-100 gap-4 px-md-6 px-0'>
          <div
            className='p-6 rounded-2 w-100'
            style={{background: `${mode === 'dark' ? '#45465A' : '#EFF6FF'}`}}
          >
            <img src={`${mode === 'dark' ? icGrowDark : icGrow}`} alt='' className='mb-4' />
            <p
              className={`m-0 font-size-14 fw-semibold ${
                mode === 'dark' ? 'text-white' : 'text-primary'
              }`}
            >
              {formatMessage({id: 'No price hikes ever'})}
            </p>
            <p className={`m-0 mt2 ${mode === 'dark' ? 'text-white' : 'text-muted'}`}>
              {formatMessage({id: 'Secure the lowest pricing, forever'})}
            </p>
          </div>

          <div
            className='p-6 rounded-2 w-100'
            style={{background: `${mode === 'dark' ? '#45465A' : '#EFF6FF'}`}}
          >
            <img src={`${mode === 'dark' ? icCheckDark : icCheck}`} alt='' className='mb-4' />
            <p
              className={`m-0 font-size-14 fw-semibold ${
                mode === 'dark' ? 'text-white' : 'text-primary'
              }`}
            >
              {formatMessage({id: 'Pay once, save for life'})}
            </p>
            <p className={`m-0 mt2 ${mode === 'dark' ? 'text-white' : 'text-muted'}`}>
              {formatMessage({id: 'No hidden fees, no surprises'})}
            </p>
          </div>
        </div>

        <div className='d-flex flex-column flex-md-row justify-between mt-4 w-100 gap-4 px-md-6 px-0'>
          <div
            className='p-6 rounded-2 w-100'
            style={{background: `${mode === 'dark' ? '#45465A' : '#EFF6FF'}`}}
          >
            <img src={`${mode === 'dark' ? icAlertDark : icAlert}`} alt='' className='mb-4' />
            <p
              className={`m-0 font-size-14 fw-semibold ${
                mode === 'dark' ? 'text-white' : 'text-primary'
              }`}
            >
              {formatMessage({id: '100% risk-free'})}
            </p>
            <p className={`m-0 mt-2 ${mode === 'dark' ? 'text-white' : 'text-muted'}`}>
              {formatMessage({id: `If you don't love it, cancel anytime`})}
            </p>
          </div>

          <div
            className='p-6 rounded-2 w-100'
            style={{background: `${mode === 'dark' ? '#45465A' : '#EFF6FF'}`}}
          >
            <img src={`${mode === 'dark' ? icUserDark : icUser}`} alt='' className='mb-4' />
            <p
              className={`m-0 font-size-14 fw-semibold ${
                mode === 'dark' ? 'text-white' : 'text-primary'
              }`}
            >
              {formatMessage({id: 'Only 100 spots available'})}
            </p>
            <p className={`m-0 mt2 ${mode === 'dark' ? 'text-white' : 'text-muted'}`}>
              {formatMessage({id: 'Secure yours now!'})}
            </p>
          </div>
        </div>

        <div className='text-center mt-8'>
          <button
            className='btn btn-primary'
            onClick={!isOfferClaimed ? handleOfferClick : undefined}
            disabled={isOfferClaimed}
          >
            {isOfferClaimed
              ? formatMessage({id: 'Your Application Under Review'})
              : formatMessage({id: 'Get Early Adopter Offer'})}
          </button>
        </div>

        <EarlySocialMedia />
      </div>
      <InviteModal isActive={isActive} setIsActive={setIsActive} />
    </>
  )
}
